<div id="dodPopupContainer">
  <ng-template #dodPopupInsertionPoint></ng-template>
</div>

<div [ngStyle]="{'z-index': zIndex}" class="definitionOfDoneWidget" #divcontainer>
  <button mat-raised-button class="resetButton" (click)="reset($event)">
    <mat-icon>replay</mat-icon>
  </button>

  <div class="widget">
    <h3 class="widget-title" [translate]="'widgets.definitionOfDone.name'">Defintiniton of Done</h3>
    <div class="container-dod">
      <ul class="list-dod">
        <li *ngFor="let option of definitionOfDones, let i = index">
          <table class="table-dod">
            <tr>
              <th>
                <mat-slide-toggle [checked]="option.active" (change)="changeActive(option.id)"></mat-slide-toggle>
              </th>
              <th>
                <label class="label-dod" *ngIf="!editMode">{{option.name}}</label>
                <textarea placeholder="Definition of Done" class="textarea-dod" id="dod-id-{{option.id}}"
                          (input)="onChangeText(option.id)" *ngIf="editMode" [(ngModel)]="option.name"></textarea>
              </th>
              <th>
                <button mat-raised-button id="button-dod-{{option.id}}" style="display:none;"
                        *ngIf="option.name !== '' && option.name !== null" (click)="changeName(option.id, option.name)">
                  <mat-icon>save</mat-icon>
                </button>
              </th>
              <th>
                <button *ngIf="editMode" mat-raised-button id="button-del-dod-{{option.id}}" (click)="deleteDoD(option)">
                  <mat-icon>delete</mat-icon>
                </button>
              </th>
              <hr class="hr-dod">
            </tr>
          </table>
        </li>
        <li>
          <table>
            <th>
              <!--TODO - Change static String-->
              <textarea class="textarea-dod-add-new" id="newDoD" placeholder="Add a new DoD here"
                        [(ngModel)]="newDoDValue"></textarea>
            </th>
            <th>
              <button mat-raised-button id="button-dod-add" (click)="addNewDoD()"
                      *ngIf="newDoDValue && newDoDValue !== ''">
                <mat-icon>save</mat-icon>
              </button>
            </th>
          </table>
          <div class="dod-cancel-editMode">
            <table *ngIf="editMode">
              <th>
                <!--TODO: chagne static string-->
                <label>Done</label>
              </th>
              <th>
                <button mat-raised-button id="exitEditMode" (click)="leaveEditMode()">
                  <mat-icon>done</mat-icon>
                </button>
              </th>
            </table>
          </div>
        </li>
      </ul>
    </div>

    <hr>

    <!-- Active for Project -->
    <div class="card-field active-for-project">
      <div class="label">
        <p>Active for project</p>
      </div>
      <div class="content">
          <mat-slide-toggle [checked]="definitionOfDoneActive" (change)="changeProjectActive()"
                            [translate]="'widgets.definitionOfDone.activeForProject'">
          </mat-slide-toggle>
      </div>
    </div>

    <!-- DoD version -->
    <div class="card-field DoD Version">
      <div class="label">
        <p>Issuecard Version</p>
      </div>
      <div class="content">
        <mat-form-field>
          <mat-select [value]="this.definitionOfDoneDisplayType" (selectionChange)="versionChanged($event.value)">
            <mat-option *ngFor="let version of this.getAllVersion()" [value]="version">{{version}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div>
      <p>
        <button mat-raised-button *ngIf="!editMode" (click)="editMode=true">
          <mat-icon>edit</mat-icon>
        </button>
      </p>
    </div>
  </div>
</div>
